import { __assign, __awaiter, __generator, __makeTemplateObject } from "tslib";
import { getState, setState, addScriptDependency, installDependencies, mutatePackageJSON } from '../utils';
import fs from 'fs';
import path from 'path';
import dedent from 'dedent';
import appRoot from 'app-root-path';
var storybookDir = path.join(appRoot.path, '.storybook');
export var addReact = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (getState().hasAddedReact) {
                    return [2, console.log('Already added React')];
                }
                if (fs.existsSync(storybookDir)) {
                    return [2, console.log(dedent(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        This script installs and configures storybook.\n        Remove your '.storybook' directory and any storybook packages\n        (but keep your stories!) before running this script\n      "], ["\n        This script installs and configures storybook.\n        Remove your '.storybook' directory and any storybook packages\n        (but keep your stories!) before running this script\n      "]))))];
                }
                addScriptDependency('https://unpkg.com/react/umd/react.production.min.js', 'https://unpkg.com/react-dom/umd/react-dom.production.min.js');
                return [4, installDependencies(['react', 'react-dom'], 'peer')];
            case 1:
                _a.sent();
                return [4, installDependencies([
                        '@babel/preset-react',
                        '@testing-library/react',
                        '@types/react',
                        '@types/react-dom',
                        '@types/testing-library__react',
                        'babel-preset-react-app',
                        'eslint-plugin-react',
                        'eslint-plugin-react-hooks',
                        'react',
                        'react-dom',
                        'react-test-renderer',
                        '@storybook/addon-actions',
                        '@storybook/addon-essentials',
                        '@storybook/addon-knobs',
                        '@storybook/addon-links',
                        '@storybook/react',
                        'storybook'
                    ], 'dev')];
            case 2:
                _a.sent();
                fs.mkdirSync(storybookDir);
                fs.writeFileSync(path.join(storybookDir, 'main.js'), dedent(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      module.exports = {\n        stories: [\n          \"../src/**/*.stories.mdx\",\n          \"../src/**/*.stories.@(js|jsx|ts|tsx)\"\n        ],\n        addons: [\n          \"@storybook/addon-links\",\n          \"@storybook/addon-essentials\",\n          \"@storybook/addon-knobs/register\"\n        ]\n      }\n    "], ["\n      module.exports = {\n        stories: [\n          \"../src/**/*.stories.mdx\",\n          \"../src/**/*.stories.@(js|jsx|ts|tsx)\"\n        ],\n        addons: [\n          \"@storybook/addon-links\",\n          \"@storybook/addon-essentials\",\n          \"@storybook/addon-knobs/register\"\n        ]\n      }\n    "]))) + '\n');
                fs.writeFileSync(path.join(storybookDir, 'preview.js'), dedent(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      export const parameters = {\n        actions: { argTypesRegex: \"^on[A-Z].*\" },\n      }\n    "], ["\n      export const parameters = {\n        actions: { argTypesRegex: \"^on[A-Z].*\" },\n      }\n    "]))) + '\n');
                mutatePackageJSON({
                    scripts: function (prev) { return (__assign(__assign({}, prev), { start: 'stmux -c line -w error -e ERROR -m beep,system -M -- [ "yarn watch" : "yarn storybook" ]', storybook: 'start-storybook' })); }
                });
                setState({ hasAddedReact: true });
                return [2];
        }
    });
}); };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map